var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationLockopen = function SvgSimpleIllustrationLockopen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__lockopen_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__lockopen_svg__st1{fill:#002140}.simple-illustration__lockopen_svg__st2{fill:#d18000}")), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 22.4c-.1-1.1-.1-1.9-.1-1.9S47.4 6.6 34 7c-13.3.4-16.3 13.2-16.3 13.2l-.4 7.6 6.8-.2v-6.2s2.2-7.5 9.9-7.6c7.7-.1 9.6 7.3 9.6 7.3l.2 1.2 6.7.1z",
    style: {
      fill: "#e4bc07"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 28.6c-.3 0-.5-.2-.5-.5v-4.7C23.7 17.6 28.3 13 34 13c5.2 0 9.5 3.8 10.3 8.8l6.4.2c.3 0 .5.2.5.5s-.2.5-.5.5l-6.8-.2c-.2 0-.5-.2-.5-.4-.6-4.8-4.6-8.4-9.4-8.4-5.2 0-9.4 4.2-9.4 9.4v4.7c.1.2-.2.5-.4.5z",
    className: "simple-illustration__lockopen_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 28.6c-.3 0-.5-.2-.5-.5v-4.4c0-9.5 7.7-17.2 17.2-17.2 8.9 0 16.5 7 17.1 15.9 0 .3-.2.5-.5.5-.2 0-.5-.2-.5-.5-.6-8.4-7.7-15-16.1-15-8.9 0-16.2 7.3-16.2 16.2V28c0 .3-.3.6-.5.6z",
    className: "simple-illustration__lockopen_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 31-.3-2.4s.4-.6-1.6-.6h-5.4s-1.1.1-1.1 1v2h8.4zM51.7 31l-.3-2.4s.4-.6-1.6-.6-5.4.1-5.4.1-1.1.1-1.1 1V31h8.4z",
    className: "simple-illustration__lockopen_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.9 31.2H14v13.7s.4 16.6 21.2 16.5c13.7 0 18.9-12.3 19.1-17.4s-.4-12.8-.4-12.8z",
    style: {
      fill: "#ff7101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 31.1h-4v14.2s1.5 15.5 17.9 15.9c0 0-13.3-3.3-14.2-18-.5-8.3.3-12.1.3-12.1z",
    style: {
      fill: "#bf3013"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 34.4s3.5 2.2 3.5 4.5-1.5 5.1-2.4 5.4L38.1 56l2.9-.5-1.8-12s3.1-2 2.6-4.5c-.6-2.4-2.3-5.5-6.7-4.6z",
    className: "simple-illustration__lockopen_svg__st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 44.3s2.5-2.3 2.5-4.7c0-2.5-2.4-4.8-4.3-4.8s-3.1 3.2-3.1 3.8c0 .7 1.1 4 2.5 4.9l-2.3 12.2s5.3 1.1 6.6.3l-1.9-11.7z",
    className: "simple-illustration__lockopen_svg__st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 61.9C25.5 61.9 17 53.4 17 43V31.1c0-.3.2-.5.5-.5h36.7c.3 0 .5.2.5.5V43c0 10.4-8.5 18.9-18.8 18.9zM18 31.6V43c0 9.8 8 17.8 17.8 17.8s17.8-8 17.8-17.8V31.6H18z",
    className: "simple-illustration__lockopen_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 61.9C22 61.9 13.5 55 13.5 43V31.1c0-.3.2-.5.5-.5h4.6c.3 0 .5.2.5.5s-.2.5-.5.5h-4.1V43c0 6.7 2.9 17.8 22.3 17.8.3 0 .5.2.5.5s-.3.6-.5.6z",
    className: "simple-illustration__lockopen_svg__st1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57.2c-2.9 0-4.9-1.2-5.1-1.2-.2-.1-.3-.3-.2-.5L33.2 44c-1.5-1.1-2.5-2.8-2.5-4.7 0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7v.1c0 2-1.1 3.8-2.8 4.8l2.1 11.3c0 .2-.1.4-.3.5-1.8.9-3.6 1.2-5.1 1.2zm-4.2-1.9c1 .5 4.5 1.8 8.5 0l-2-11.3c0-.2.1-.4.3-.5 1.6-.8 2.6-2.4 2.6-4.2v-.1c0-2.5-2.1-4.6-4.7-4.6s-4.7 2.1-4.7 4.7c0 1.6.8 3.1 2.3 4 .2.1.3.3.2.5l-2.5 11.5z",
    className: "simple-illustration__lockopen_svg__st1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9 56.5c-.2 0-.4-.2-.5-.4l-2.1-11.6c0-.2.1-.4.3-.5 1.6-.8 2.6-2.4 2.6-4.2 0-2.2-1.6-4.1-3.7-4.6-.3-.1-.4-.3-.4-.6s.3-.4.6-.4c2.6.5 4.5 2.9 4.5 5.6 0 2-1.1 3.9-2.8 4.9L38.5 56c-.1.2-.3.4-.6.5zM25.2 31.4c-.3 0-.5-.2-.5-.5V29c0-.3-.4-.6-.8-.6H18c-.5 0-.8.3-.8.6v1.9c0 .3-.2.5-.5.5s-.5-.2-.5-.5V29c0-.9.8-1.6 1.8-1.6h5.9c1 0 1.8.7 1.8 1.6v1.9c0 .3-.2.5-.5.5zM51.7 31.4c-.3 0-.5-.2-.5-.5V29c0-.3-.4-.6-.8-.6h-5.9c-.5 0-.8.3-.8.6v1.9c0 .3-.2.5-.5.5s-.5-.2-.5-.5V29c0-.9.8-1.6 1.8-1.6h5.9c1 0 1.8.7 1.8 1.6v1.9c0 .3-.2.5-.5.5z",
    className: "simple-illustration__lockopen_svg__st1"
  })));
};
export default SvgSimpleIllustrationLockopen;